import React from 'react'
import { ImportantIcon } from '@ow/icons'
import RenderIf from '../../render-if'
import {
  StyledItems,
  StyleBox,
  StyledCategory,
  StyledTitles,
  StyledTitlesName,
  StyledTimes,
  StyledLabels,
  StyledLabel,
  StyledSummarys,
  StyledContent,
  StyledDetails,
  StyledDownload,
  StyledSource,
  StyledImportantTitles,
} from '../styled/article'

const Article = (props) => {
  const {
    category,
    title,
    subtitle,
    important,
    datetime,
    label,
    content,
    onClick,
    download,
    details,
    onClickdownload,
    onClickDetails,
    showMore,
    showOtherColor,
    source,
  } = props
  const getTagFn = () => {
    // showOtherColor  是否显示其他颜色
    let tags = ''
    if (label && !Array.isArray(label)) {
      tags = `#${label}#`
    } else {
      tags = ` #
      ${
        label &&
        label.map((i) => {
          return ` ${i} `
        })
      }
      #`
    }
    return showOtherColor ? (
      <StyledLabel>{tags}</StyledLabel>
    ) : (
      <StyledLabels>{tags}</StyledLabels>
    )
  }
  // 获取标题
  const getTitle = () => {
    const _title = subtitle || title
    return (
      <StyledTitlesName title={subtitle}>
        {important ? (
          <StyledImportantTitles>
            <span className="inline-block relative top-1">
              <ImportantIcon width={40} height={20} />
            </span>
            <span>{_title}</span>
          </StyledImportantTitles>
        ) : (
          _title
        )}
      </StyledTitlesName>
    )
  }
  return (
    <StyledItems onClick={onClick}>
      <StyleBox>
        <div className="flex items-center">
          <RenderIf isTrue={category}>
            <StyledCategory title={category}>{category}</StyledCategory>
          </RenderIf>
          {getTitle()}
        </div>
        <RenderIf isTrue={datetime}>
          <StyledTimes>{datetime}</StyledTimes>
        </RenderIf>
        <RenderIf isTrue={download}>
          <StyledDownload
            onClick={(event) => {
              event.stopPropagation()
              onClickdownload(download)
            }}
          >
            下载
          </StyledDownload>
        </RenderIf>
      </StyleBox>
      <RenderIf isTrue={label}>{getTagFn()}</RenderIf>
      <RenderIf isTrue={source}>
        <StyledSource>
          来源：
          {source && source.indexOf('http') === -1 ? (
            source
          ) : (
            <a href={source} target="_blank" rel="noreferrer">
              {source}
            </a>
          )}
        </StyledSource>
      </RenderIf>
      <RenderIf isTrue={subtitle}>
        <StyledTitles title={title}>{title}</StyledTitles>
      </RenderIf>
      <RenderIf isTrue={content}>
        {showMore ? (
          <StyledContent className="ow-text-color">{content}</StyledContent>
        ) : (
          <StyledSummarys className="ow-text-color">{content}</StyledSummarys>
        )}
      </RenderIf>

      <RenderIf isTrue={details}>
        <StyledDetails>
          <div
            onClick={(event) => {
              event.stopPropagation()
              onClickDetails(content)
            }}
          >
            详情
          </div>
        </StyledDetails>
      </RenderIf>
    </StyledItems>
  )
}

export default Article
